import { BaseEntity, Column, CreateDateColumn, Entity, Index, JoinColumn, ManyToOne, PrimaryGeneratedColumn, UpdateDateColumn, VersionColumn } from "typeorm";
import { Asn } from "./asn.entity";

@Entity("asn_items")

export class AsnItems {

    @PrimaryGeneratedColumn("increment", {
        name: "asn_item_id"
    })
    asnItemId: number;

    @Column("int", {
        name: "asn_id"
    })
    asnId: number;

    @Column("int", {
        name: "po_id"
    })
    poId: number;

    @Column("int", {
        name: "po_item_id"
    })
    poItemId: number;

    @Column("int", {
        nullable: false,
        name: "item_id"
    })
    itemId: number;  
    
    @Column("int", {
        nullable: true,
        name: "size_id",
        default:0,
        comment: "size id not using"
    })
    sizeId: number;

    @Column("int", {
        nullable: false,
        name: "po_quantity"
    })
    poQuantity: number;

    @Column({
        type: "int",
        nullable: false,
        name: "asn_quantity",
        default: 0,
        unsigned:true
    })
    asnQuantity: number;
   
    @CreateDateColumn({ name: "created_at" })
    createdAt: Date;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: "created_user"
    })
    createdUser: string | null;

    @UpdateDateColumn({ name: "updated_at" })
    updatedAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

   

    @VersionColumn({
        default: 1,
        name: "version_flag"
    })
    versionFlag: number;

    @ManyToOne(type => Asn, asn => asn.asnItemsInfo, { nullable: false, })
    @JoinColumn({ name: "asn_id" })
    asnInfo: Asn[];
}

